export const CREATE_SHIPPING_PARTNER = {
    REQUEST: 'SHIPPING_PARTNER.CREATE.REQUEST',
    SUCCESS: 'SHIPPING_PARTNER.CREATE.SUCCESS',
    FAILED: 'SHIPPING_PARTNER.CREATE.FAILED',
};
